import {
  Box,
  Button,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Typography,
  styled,
} from "@mui/material";
import React from "react";

import { primary } from "../../constants/theme";

const TenureComponentStyle = styled(Box)(({ theme }) => ({
  ".radioLabelStyle": {
    fontWeight: "700",
    fontSize: "14px",
    //lineHeight: "30px",
    color: primary.main,
  },
  ".btnStyle": {
    fontFamily: "Poppins",
    fontStyle: "normal",
    fontWeight: "700",
    fontSize: "10px",

    background: "#E8345E",

    textTransform: "capitalize",
    borderRadius: "20px",
    "&:hover": {
      color: "#E8345E",
      background: "#fff",
    },
  },
}));

const TenureRadioButton = (props) => {
  const { handleDuration, handleSubmit } = props;
  return (
    <TenureComponentStyle>
      <Box>
        <form onSubmit={handleSubmit}>
          <FormLabel id="demo-error-radios" className="tenure">
            Tenure
          </FormLabel>
          <RadioGroup defaultValue={handleDuration}>
            <FormControlLabel
              value={36}
              control={<Radio style={{ color: primary.mainGreen }} />}
              label={
                <Typography style={{ fontWeight: "bold", color: primary.main }}>
                  36 Months
                </Typography>
              }
            />
          </RadioGroup>
        </form>
      </Box>
    </TenureComponentStyle>
  );
};

export default TenureRadioButton;
